import { Availability } from '../domain/Availability'
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'

@Component({
    selector: 'app-no-availability',
    templateUrl: './no-availability.component.html',
})
export class NoAvailabilityComponent implements OnChanges {

    @Input() availability!: Availability
    @Input() requiresDogFriendly!: boolean | null
    @Input() requiresWheelchairAccess!: boolean | null
    @Input() requiresPramAccessible!: boolean | null
    @Input() requiresHighchairFriendly!: boolean | null
    @Input() idealTime!: Date | null
    @Input() partySize!: number
    @Input() areaId!: string | null
    @Input() eventId!: string | null
    @Input() reasonId!: string | null
    @Output() joinWaitlistRequested = new EventEmitter<void>()

    showJoinWaitlistButton = false

    ngOnChanges() {
        this.showJoinWaitlistButton = this.availability.shouldShowJoinWaitlistButton(
            this.idealTime,
            this.areaId,
            this.reasonId
        )
    }
}
